var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"baColorDeepBlue","flat":"","height":"71"}},[_c('v-spacer'),_c('div',{staticClass:"my-auto ml-4"},[_c('v-btn',{attrs:{"text":""},on:{"click":_vm.signOut}},[_c('best-athletes-logo')],1)],1),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }